const dealerDefault = [
  { Minimum: 0.00, Maximum: 79.99, Color: "#eb331e", Smiley: "frown-open" },
  { Minimum: 80.00, Maximum: 89.99, Color: "#ffe20a", Smiley: "meh" },
  { Minimum: 90.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
];
const corporateDefault = [
  { Minimum: 0.00, Maximum: 89.99, Color: "#eb331e", Smiley: "frown-open" },
  { Minimum: 90.00, Maximum: 94.99, Color: "#ffe20a", Smiley: "meh" },
  { Minimum: 95.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
];
const motorradDefault = [
  { Minimum: 0.00, Maximum: 59.99, Color: "#eb331e", Smiley: "frown-open" },
  { Minimum: 60.00, Maximum: 79.99, Color: "#ffe20a", Smiley: "meh" },
  { Minimum: 80.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
];
const leadFuDefault = [
  { Minimum: 0.00, Maximum: 89.99, Color: "#eb331e", Smiley: "frown-open" },
  { Minimum: 90.00, Maximum: 99.99, Color: "#ffe20a", Smiley: "meh" },
  { Minimum: 100.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
];
const defaultTh = [
  { Minimum: 0.00, Maximum: 33.49, Color: "#f00", Smiley: "frown-open" },
  { Minimum: 33.5, Maximum: 66.50, Color: "#77f", Smiley: "meh" },
  { Minimum: 66.51, Maximum: 100.00, Color: "#0f0", Smiley: "grin" }
];
const lmDefault = [
  { Minimum: 0.00, Maximum: 79.99, Color: "#ff2832", Smiley: "frown-open" }, // "#eb331e"
  { Minimum: 80.00, Maximum: 89.99, Color: "#ffff79", Smiley: "meh" }, // "#ffe20a"
  { Minimum: 90.00, Maximum: 100.00, Color: "#a0d28f", Smiley: "grin" } // "#42cf76"
];

const testDriveConductedDefault = [
  { Minimum: 0.00, Maximum: 49.99, Color: "#eb331e", Smiley: "frown-open" },
  { Minimum: 50.00, Maximum: 79.99, Color: "#ffe20a", Smiley: "meh" },
  { Minimum: 80.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
];

export default {
  methods: {
    getNamedThreshold(name) {
      switch (name) {
        case 'dealer':
          return dealerDefault;
        case 'corporate':
          return corporateDefault;
        case 'motorrad':
          return motorradDefault;
        case 'leadFu':
          return leadFuDefault;
        case 'lm':
          return lmDefault;
        case 'testDriveConducted':
          return testDriveConductedDefault;
        default:
          return undefined;
      }
    },
    
    getRelevantThresholds() {
      return [
        { name: 'default',  subTitle: 'all values in %',        threshold: undefined },
        { name: 'lm',       subTitle: 'LM/xEV/My BMW MINI App', threshold: JSON.parse(JSON.stringify(lmDefault)) },
        { name: 'lfu',      subTitle: 'Lead Follow up',         threshold: JSON.parse(JSON.stringify(leadFuDefault)) },
        { name: 'tdc',      subTitle: 'Test Drive conducted',   threshold: JSON.parse(JSON.stringify(testDriveConductedDefault)) },
      ];
    },

    defaultThreshold() {
      return defaultTh;
    },
    dealerDefaultThreshold() {
      return dealerDefault;
    },
    corporateDefaultThreshold() {
      return corporateDefault;
    },
    motorradDefaultThreshold() {
      return motorradDefault;
    },
    testDriveConductedThreshold(thresholds) {
      return this.makeThreshold(thresholds, testDriveConductedDefault);
    },
    makeCorporateThreshold(thresholds) {
      return this.makeThreshold(thresholds, corporateDefault);
    },
    makeLeadFuThresholds(thresholds) { 
      return this.makeThreshold(thresholds, leadFuDefault);
    },
    getLMThresholds(thresholds) { 
      return this.makeThreshold(thresholds, lmDefault);
    },
    makeThreshold(thresholds, defaults) {
      if (!thresholds || thresholds.length != 3)
        return defaults;

      let result = [];
      for (let i = 0; i < thresholds.length; i++) {
        const el = thresholds[i];
        result.push({
          Minimum: defaults[i].Minimum, 
          Maximum: defaults[i].Maximum,
          Color: el.Color, 
          Smiley: el.Smiley
        });
      }
      return result;
    },
    getThresholdTextRounded(thItem, showPercent=false) {
      let pcntSign = showPercent ? '%' : '';
      if (Math.round(thItem.Minimum) == Math.round(thItem.Maximum)) {
        return `${Math.round(thItem.Maximum)}${pcntSign}`;
      } else {
        return `${Math.round(thItem.Minimum)}${pcntSign}-${Math.round(thItem.Maximum)}${pcntSign}`;
      }
    },
    getThresholdText(items, th) {
      if (th == _.last(items)) {
        if (Math.floor(th.Minimum) == Math.floor(th.Maximum)) {
          return `${Math.floor(th.Maximum)}`;
        } else {
          return `${Math.floor(th.Minimum)}-${Math.floor(th.Maximum)}`;
        }
      } else {
        return `${Math.floor(th.Minimum)}-${Math.floor(th.Maximum)}`;
      }
    }
  }
};